export const GET_ORGANIZATION_DETAILS = "GET_ORGANIZATION_DETAILS";
export const GET_ORGANIZATION_RESOURCES = "GET_ORGANIZATION_RESOURCES";
export const ORGANIZATION_RESOURCES_LIST = "ORGANIZATION_RESOURCES_LIST";
export const SET_ORGANIZATION_NAME = "SET_ORGANIZATION_NAME";
export const SAVE_ORGANIZATION = "SAVE_ORGANIZATION";
export const FETCHING_ORGANIZATION_DETAILS = "FETCHING_ORGANIZATION_DETAILS";
